import EndPoints from '@/constants/dxApiEndpoints'
import BaseService from './baseService'
import {
  productImages,
  productImageDetail,
  ProductImageRequest,
  ProcessedImageResponse,
  ProcessedImageRequest
} from '@/types/ProductImageDetails'

class ProductImageService extends BaseService {
  getProductImageDetails = async (
    businessProfileId: number,
    productCatalogId: number,
    productId: number
  ): Promise<Array<productImageDetail>> => {
    const productResponse = await this.apiClient.get<{
      data: Array<productImageDetail>
    }>(
      EndPoints.ProductImageDetails(
        businessProfileId,
        productCatalogId,
        productId
      )
    )
    return productResponse.data
  }

  getProductVariantImageDetails = async (
    businessProfileId: number,
    productCatalogId: number,
    productVariantId: number
  ): Promise<Array<productImageDetail>> => {
    const productResponse = await this.apiClient.get<{
      data: Array<productImageDetail>
    }>(
      EndPoints.ProductVariantImageDetails(
        businessProfileId,
        productCatalogId,
        productVariantId
      )
    )
    return productResponse.data
  }

  getProductImages = async (
    businessProfileId: number,
    productCatalogId: number,
    request: ProductImageRequest
  ): Promise<Array<productImages>> => {
    const productResponse = await this.apiClient.get<{
      data: Array<productImages>
    }>(EndPoints.productImages(businessProfileId, productCatalogId), request)
    return productResponse.data
  }

  applyBackgroundRemove = async (
    businessProfileId: number,
    productCatalogId: number,
    productImageIds: number[]
  ): Promise<ProcessedImageResponse[]> => {
    const response = await this.apiClient.post<{
      data: ProcessedImageResponse[]
    }>(
      EndPoints.applyBackgroundRemove(businessProfileId, productCatalogId),
      productImageIds
    )
    return response.data
  }
  downloadProcessedImages = async (
    businessProfileId: number,
    productCatalogId: number,
    request: ProcessedImageRequest
  ): Promise<Blob> => {
    const response = await this.apiClient.get(
      EndPoints.downloadProcessedImages(businessProfileId, productCatalogId),
      {
        ...request
      },
      {
        responseType: 'blob'
      }
    )

    return new Blob([response as BlobPart], {
      type: 'text/csv'
    })
  }
}

export default ProductImageService
